/* eslint-disable react/no-unescaped-entities */
import { FC } from 'react'
import { useRouter } from 'next/router'
import { Language } from 'types/language'
import styles from './Terms.module.scss'

const Terms: FC = () => {
  // Next router
  const { locale: language } = useRouter()

  const renderDutch = () => {
    return (
      <div className={styles.terms}>
        <h2>
          Algemene Voorwaarden voor de levering van elektriciteit en/of aardgas door Bolt Energie B.V. (hierna “wij”) aan de klant (hierna
          “u”) en de teruglevering van elektriciteit _ 01/02/2021
        </h2>
        <h3>1. De definities en toepassing Algemene Voorwaarden (hierna “AV”)</h3>
        <p>
          <strong>Bijzondere Voorwaarden</strong>: ons document waarin de prijs, de Teruglevergoeding, de duur en de bijzondere bepalingen
          van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst worden vermeld (hierna “BV”).
          <br />
          <strong>Consument</strong>: iedere natuurlijke persoon die elektriciteit en/of aardgas aankoopt voor doeleinden die buiten zijn
          handels-, bedrijfs-, ambachts- of beroepsactiviteit vallen, tenzij anders bepaald in de toepasselijke regelgeving.
          <br />
          <strong>Kleine Professionele Verbruiker</strong>: iedere natuurlijke persoon of rechtspersoon die elektriciteit en/of aardgas
          aankoopt gedeeltelijk of uitsluitend voor professionele doeleinden, en waarvan het jaarlijks verbruik voor al zijn Leverpunten
          samen minder dan 50 MWh elektriciteit en minder dan 100 MWh aardgas bedraagt voor contracten die vóór 1 september 2021 worden
          gesloten, gewijzigd of hernieuwd en minder dan 100 MWh elektriciteit en/of minder dan 100 MWh aardgas voor contracten die vanaf 1
          september 2021 worden gesloten, gewijzigd of hernieuwd.
          <br />
          <strong>Levering</strong>: het voorzien op het Leverpunt van elektriciteit en/of aardgas.
          <br />
          <strong>Leveringsovereenkomst</strong>: het geheel van de overeenkomst tussen u en ons betreffende de Levering; de AV, de BV
          evenals elke schriftelijke aanvulling of aanpassing daarvan maken deel uit van deze Leveringsovereenkomst; in geval van
          tegenstrijdigheden hebben de BV voorrang.
          <br />
          <strong>Leverpunt</strong>: het overeengekomen punt waar wij elektriciteit en/of aardgas leveren en waar u desgevallend ook
          elektriciteit teruglevert aan Bolt; dit punt heeft een uniek EAN-nummer.
          <br />
          <strong>Netbeheerder</strong>: de beheerder van het nationaal, regionaal of lokaal net voor de transmissie, het vervoer of de
          distributie van elektriciteit en/of aardgas.
          <br />
          <strong>Nettarieven</strong>: de tarieven voor het gebruik van het distributie-, lokaal transport- en/of transmissienet voor
          elektriciteit en aardgas.
          <br />
          <strong>Producent Elektriciteit</strong>: de door Bolt aangeboden en door u gekozen producent van lokale en groene elektriciteit.
          <br />
          <strong>Teruglevering</strong>: de verkoop van door de klant geproduceerde en op het Leverpunt geïnjecteerde elektriciteit aan
          Bolt.
          <br />
          <strong>Terugleveringsovereenkomst</strong>: het geheel van de overeenkomst tussen u en ons betreffende de Teruglevering; de AV,
          de BV evenals elke schriftelijke aanvulling of aanpassing daarvan maken deel uit van deze Leveringsovereenkomst en/of
          Terugleveringsovereenkomst; in geval van tegenstrijdigheden hebben de BV voorrang.
          <br />
          <strong>Terugleveringsvergoeding</strong>: de vergoeding die Bolt aan de klant betaalt voor de door hem geproduceerde en op het
          Leverpunt geïnjecteerde elektriciteit.
        </p>
        <p>
          De begrippen die niet in deze Leveringsovereenkomst en/of Terugleveringsovereenkomst zijn gedefinieerd, hebben de betekenis zoals
          vastgelegd in de toepasselijke regelgeving (inclusief de technische reglementen). Voor meer uitleg over de regionale regelgevingen
          verwijzen wij naar de websites van de bevoegde regulatoren.
        </p>
        <p>
          Deze AV zijn van toepassing op de levering van elektriciteit en aardgas aan Consumenten en aan Kleine Professionele Verbruikers.
          Door de Leveringsovereenkomst te ondertekenen, stemt u in met deze AV.
        </p>
        <h3>2. Leveringsovereenkomst</h3>
        <p>
          2.1. Wij zullen elektriciteit en/of aardgas leveren zoals in de Leveringsovereenkomst bepaald. U zal op het Leverpunt onze
          elektriciteit en/of aardgas afnemen, ons de overeengekomen prijs betalen en de andere bepalingen van de Leveringsovereenkomst
          naleven. De Leveringsovereenkomst doet geen afbreuk aan de wettelijke bepalingen, o.m. inzake openbare dienstverplichtingen.
        </p>
        <p>
          2.2. Indien wij ten gevolge van wijzigingen in het regelgevend kader of door andere buiten onze invloed liggende omstandigheden
          niet voldoende uit hernieuwbare bronnen opgewekte duurzame energie beschikbaar hebben, kunnen we de levering aanvullen met
          andersoortige, maar wel zoveel mogelijk duurzaam opgewekte energie.
        </p>
        <h3>3. Terugleveringsovereenkomst</h3>
        <p>
          3.1. U kan enkel een Terugleveringsovereenkomst sluiten met Bolt als u ook een Leveringsovereenkomst met Bolt heeft afgesloten en
          u beschikt over een digitale meter op het Leverpunt. Een digitale meter meet uw afname en injectie van elektriciteit afzonderlijk
          en kan vanop afstand worden uitgelezen.
        </p>
        <p>
          3.2. Als wij een Terugleveringsovereenkomst sluiten, betaalt Bolt u een vergoeding voor de elektriciteit die u zelf produceert en
          injecteert op het Leverpunt. Deze vergoeding wordt bepaald in de BV.
        </p>

        <h3>4. Totstandkoming van de Leveringsovereenkomst en/of Terugleveringsovereenkomst</h3>
        <p>
          4.1. De Leveringsovereenkomst en/of de Terugleveringsovereenkomst komt tot stand zodra u ons aanbod heeft aanvaard en onder de
          opschortende voorwaarde van bevestiging door de netbeheerder van uw gegevens.
        </p>
        <p>
          4.2. Indien de Leveringsovereenkomst en/of de Terugleveringsovereenkomst met u op afstand wordt gesloten (bv. via onze website of
          de telefoon) of buiten de verkoopruimten van onze onderneming (bv. op evenementen, via deur-aan-deur verkoop) en u een Consument
          bent, zal de Leveringsovereenkomst en/of Terugleveringsovereenkomst u schriftelijk (per brief of per e-mail) worden bevestigd.
        </p>
        <p>
          4.3. Voor zover toegelaten door en overeenkomstig de toepasselijke regelgeving, kunnen wij u als klant weigeren indien wij
          objectieve redenen hebben om te twijfelen aan uw kredietwaardigheid. Bovendien kunnen wij van u, voor zover toegelaten door en
          overeenkomstig de toepasselijke regelgeving, een waarborg vragen in de volgende gevallen:
        </p>
        <ol type="a">
          <li>u heeft nog openstaande schulden bij ons (in welk geval u tevens eerst uw schulden moet aflossen); en/of</li>
          <li>
            in een periode van 24 maanden voorafgaand aan het afsluiten van de Leveringsovereenkomst of tijdens de duur van de
            Leveringsovereenkomst heeft u twee of meerdere facturen niet tijdig betaald.
          </li>
        </ol>
        <p>
          Indien u niet voldoet aan de vraag tot waarborg binnen een termijn van 15 kalenderdagen, kunnen wij u eveneens als klant weigeren.
        </p>
        <p>
          De waarborg zal hoogstens 3 maanden geschat verbruik bedragen, en mag door ons worden gebruikt om uw schulden aan te zuiveren. De
          waarborg zal eventueel na compensatie met nog openstaande bedragen, overeenkomstig de toepasselijke regelgeving, worden
          teruggestort binnen de 30 kalenderdagen na onze eindfactuur. In alle gevallen kan u de waarborg terugvragen van zodra u gedurende
          één jaar al uw facturen stipt heeft betaald zonder betalingsherinnering en u bij ons geen openstaande schuld meer heeft, tenzij de
          toepasselijke regelgeving anders bepaalt.
        </p>
        <p>
          4.4. De Levering en/of Teruglevering start zodra wij door de Netbeheerder als leverancier voor het Leverpunt en/of, in geval van
          Teruglevering, als koper van de door de klant op het Leverpunt geïnjecteerde elektriciteit in het aansluitingsregister of
          toegangsregister werden geregistreerd. Indien u een Consument bent en de Leveringsovereenkomst en/of de Terugleveringsovereenkomst
          op afstand of buiten de verkoopruimten van onze onderneming of onze partners werd gesloten, start de Levering en/of Teruglevering
          ten vroegste na afloop van de herroepingstermijn, tenzij u ons uitdrukkelijk verzoekt om de levering van elektriciteit en/of
          aardgas reeds te laten beginnen tijdens de herroepingstermijn voorzien in artikel 5.1.
        </p>
        <p>
          4.5. Consumenten die bij het afsluiten van de Leveringsovereenkomst en/of Terugleveringsovereenkomst nog gebonden zijn door een
          leveringsovereenkomst en/of terugleveringsovereenkomst met een andere leverancier met betrekking tot het Leverpunt, geven ons een
          uitdrukkelijk mandaat om voor hen deze leveringsovereenkomst en/of terugleveringsovereenkomst te beëindigen. Klanten die nog
          gebonden zijn door een terugleveringsovereenkomst met een andere partij dan een leverancier (zoals een aggregator), doen zelf het
          nodige om deze te beëindigen en het bewijs hiervan aan Bolt te bezorgen.
        </p>
        <h3>5. Herroepingsrecht</h3>
        <p>
          5.1. Als u een Consument bent, heeft u het recht om af te zien van deze Leveringsovereenkomst en/of Terugleveringsovereenkomst,
          zonder betaling van een boete en zonder opgave van motief, en dit binnen een herroepingstermijn die verstrijkt 14 kalenderdagen
          vanaf de ontvangst van de bevestiging van de Leveringsovereenkomst en/of Terugleveringsovereenkomst vanwege Bolt, of indien de
          Leveringsovereenkomst en/of Terugleveringsovereenkomst per telefoon wordt gesloten, vanaf de datum van bevestiging van de
          Leveringsovereenkomst en/of Terugleveringsovereenkomst door u. Om dit herroepingsrecht uit te oefenen, moet u Bolt via een
          ondubbelzinnige schriftelijke verklaring (bijvoorbeeld per post, fax of e-mail) op de hoogte stellen van deze beslissing. U kunt
          hiervoor gebruik maken van het modelformulier voor herroeping dat aangehecht is aan deze AV.
        </p>
        <p>
          5.2. Als u uitdrukkelijk heeft verzocht om de levering van elektriciteit en/of aardgas te laten beginnen tijdens de
          herroepingstermijn, betaalt u een bedrag dat evenredig is aan wat reeds geleverd is op het moment dat u ons in kennis stelt dat u
          de Leveringsovereenkomst herroept. Als u ervoor heeft gekozen om ook uw Terugleveringsovereenkomst te laten beginnen tijdens de
          herroepingstermijn, betaalt Bolt u een Terugleveringvergoeding voor de elektriciteit die u heeft geïnjecteerd op het Leverpunt
          vanaf de startdatum van de Terugleveringsovereenkomst tot op het moment dat u ons in kennis stelt dat u de
          Terugleveringsovereenkomst herroept.
        </p>
        <h3>6. Duur</h3>
        <p>
          6.1. De Leveringsovereenkomst en/of Terugleveringsovereenkomst wordt afgesloten voor bepaalde of onbepaalde duur. Of uw
          Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde of onbepaalde duur is, wordt vermeld in de BV.
        </p>
        <p>
          6.2. Is uw Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde duur, dan wordt/worden deze na afloop in principe
          telkens automatisch verlengd voor de duur vermeld in de BV, tenzij anders bepaald in de BV. Wij kunnen u ten minste twee maanden
          vóór de einddatum van de lopende duur meedelen dat wij de Leveringsovereenkomst en/of de Terugleveringsovereenkomst niet wensen te
          verlengen. Wij kunnen u bij die gelegenheid wel een nieuw voorstel van leveringsovereenkomst en/of terugleveringsovereenkomst
          bezorgen. U kunt ook zelf afzien van de verlenging door ons dit ten minste één maand vóór de einddatum van de lopende duur
          schriftelijk (per brief of per e-mail) mee te delen.
        </p>
        <p>
          6.3. U kan uw Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde of onbepaalde duur op ieder moment zonder kosten
          schriftelijk (per brief of per e-mail) opzeggen, mits naleving van een opzegtermijn van ten minste één maand. De afsluiting van
          het Leverpunt of de kennisgeving van de wijziging van leverancier via de Netbeheerder wordt, voor dit Leverpunt, beschouwd als een
          opzegging van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst door u.
        </p>
        <p>
          6.4. Wij kunnen de Leveringsovereenkomst en/of Terugleveringsovereenkomst van onbepaalde duur op elk moment beëindigen mits het
          respecteren van een opzegtermijn van twee maanden.
        </p>
        <p>
          6.5. De Leveringsovereenkomst loopt in alle gevallen door zolang Bolt in het toegangsregister vermeld staat als de
          verantwoordelijke voor de bevoorrading op uw Leverpunt.
        </p>
        <h3>7. Verbruik, Levering en Meting</h3>
        <p>7.1. Verbruik</p>
        <p>7.1.1. U zal de elektriciteit en/of het aardgas enkel op het Leverpunt verbruiken en niet doorleveren aan derden.</p>
        <p>
          7.1.2. Indien u toestellen gebruikt om zelf energie te produceren, dient u dit onmiddellijk aan ons te melden. Als u dit wenst,
          kan u voor de door u op het net geïnjecteerde elektriciteit een Terugleveringsovereenkomst met Bolt sluiten.
        </p>
        <p>7.2. Levering en Netbeheerder</p>
        <p>
          7.2.1. U sluit met ons de Leveringsovereenkomst en/of de Terugleveringsovereenkomst. Uw aansluiting op het net wordt door de
          Netbeheerder beheerd. De Netbeheerder is verantwoordelijk voor het functioneren van het net en de continuïteit van de Levering en
          de Teruglevering, en regelt de kwaliteit van de afname, de toevoer van elektriciteit en/of aardgas, de meetinrichting, de voor de
          aansluiting van de installaties relevante technische bepalingen evenals het aan- en afsluiten van de meters. Wij zijn geen partij
          bij deze relatie en zijn derhalve niet verantwoordelijk voor het nakomen van regels in die relatie door u of door de Netbeheerder.
        </p>
        <p>
          7.2.2. Indien de Netbeheerder de toevoer van elektriciteit en/of aardgas en/of de injectie van elektriciteit op het net beperkt of
          onderbreekt, zal de Levering en/of de Teruglevering automatisch eveneens beperkt of onderbroken worden. Deze beperking en/of
          schorsing valt buiten onze aansprakelijkheid.
        </p>
        <p>7.3. Meting</p>
        <p>
          7.3.1. De Netbeheerder bezorgt ons de stand van uw meter. Indien u ons de stand meedeelt, bent u verantwoordelijk voor de juiste
          opgave daarvan. De gegevens van de Netbeheerder hebben in elk geval voorrang.
        </p>
        <p>
          7.3.2. Zowel u als wij kunnen bij twijfel over de juistheid van de meting de meetinstallatie laten onderzoeken. Dit gebeurt op
          kosten van de verzoeker.
        </p>
        <p>
          7.3.3. Een rechtzetting van de meetgegevens en de daaruit voortvloeiende facturatie kan betrekking hebben op een periode van
          maximaal twee jaar voorafgaand aan de laatste meteropname, tenzij de toepasselijke regelgeving hierover iets anders zou bepalen.
        </p>
        <h3>8. Prijs en kosten</h3>
        <p>
          8.1. De prijs die u aan Bolt verschuldigd bent voor de Levering, bestaat uit (1) de energieprijs zoals bepaald in de BV, en (2) de
          andere bestanddelen van de prijs zoals bepaald in artikel 8.2.
        </p>
        <p>8.2. Tenzij anders bepaald wordt in de BV, wordt de energieprijs verhoogd met:</p>
        <ul>
          <li>
            de BTW, belastingen, heffingen, retributies, bijdragen, toeslagen, vergoedingen, en eventuele andere lasten en kosten die ons
            door de bevoegde overheid of reguleringsinstantie worden opgelegd;
          </li>
          <li>
            de Nettarieven, meterhuurkosten, de kosten voor de aan- of afsluiting van het Leverpunt, de eventuele bijkomende netdiensten,
            het reactief vermogen en het piekvermogen die ons opgelegd worden door de Netbeheerder.
          </li>
          <li>
            De kosten van de wettelijke verplichtingen om groene stroom-, groene warmte-, warmtekracht- en/of analoge certificaten voor te
            leggen.
          </li>
        </ul>
        <p>
          Deze bestanddelen worden rechtstreeks aan u doorgerekend, met inbegrip van de wijzigingen die buiten de verantwoordelijkheid van
          Bolt vallen, ook met terugwerkende kracht.
        </p>
        <p>
          8.3. Wij mogen alle kosten aan u aanrekenen die ons door de Netbeheerder aangerekend worden voor diensten uitgevoerd op uw vraag,
          op initiatief van de Netbeheerder of op onze vraag ten gevolge van uw nalaten of fout. Eveneens mogen wij bovenop deze kosten onze
          administratieve kosten aan u aanrekenen.
        </p>
        <p>8.4. De Terugleveringsvergoeding die Bolt aan u is verschuldigd voor de Teruglevering, wordt bepaald in de BV.</p>
        <h3>9. Facturatie en betalingsvoorwaarden</h3>
        <p>
          9.1. Wij baseren ons conform artikel 7.3 op de meetgegevens die ons ter beschikking worden gesteld en op de door de Netbeheerder
          meegedeelde verbruiksprofielen om de door u afgenomen elektriciteit en/of aardgas te factureren. Wij sturen u maandelijkse
          voorschotfacturen. De hoogte van die voorschotfacturen wordt door ons bepaald op basis van de door u verstrekte gegevens of op
          basis van de periodieke afrekening, met dien verstande dat u ons mag verzoeken de hoogte van de voorschotfacturen te herzien. In
          dat geval zullen wij u binnen een redelijke termijn informeren of wij aan uw verzoek gevolg kunnen geven. Voor zover wij uw
          meetgegevens hebben ontvangen van de Netbeheerder, bezorgen wij u jaarlijks een factuur waarin uw effectieve verbruik wordt
          afgerekend en waarin wij de reeds gefactureerde voorschotfacturen tot meteropname verrekenen. Indien wij geen meetgegevens
          ontvangen, kunnen wij u voorschotfacturen blijven sturen. Indien wij geschatte verbruiken ontvangen van de Netbeheerder, dan
          zullen wij dit geschatte verbruik effectief aanrekenen. Indien wij vaststellen dat de verbruiksgegevens foutief zijn, zullen wij
          dit melden aan de Netbeheerder en zullen wij u verder voorschotfacturen sturen. Uw effectieve verbruik zal dan later worden
          afgerekend.
        </p>
        <p>
          9.2. De betaling van onze facturen kan uitsluitend gebeuren op ons bankrekeningnummer vermeld op de factuur. U dient onze facturen
          uiterlijk binnen de 15 kalenderdagen na ontvangstdatum (indien de factuur wordt verstuurd per post, wordt deze geacht te zijn
          ontvangen op de derde dag na de verzending) te betalen. Indien u de factuur niet tijdig betaalt, zullen wij u minstens één
          herinnering sturen. Bij gebreke aan betaling binnen de in de herinnering voorziene termijn, sturen wij u een ingebrekestelling.
        </p>
        <p>
          Indien wij u een bedrag verschuldigd zijn, zullen we dit (terug)betalen binnen de betalingstermijn zoals bepaald in het eerste
          lid, tenzij:
        </p>
        <ol type="a">
          <li>
            wij niet op de hoogte zijn van uw rekeningnummer (in welk geval wij de (terug)betaling zullen doen binnen de 15 kalenderdagen
            nadat wij op de hoogte werden gebracht van uw rekeningnummer); of
          </li>
          <li>
            u nog openstaande facturen heeft, waarbij wij het recht hebben dit te compenseren overeenkomstig de bestaande regelgeving.
          </li>
        </ol>
        <p>
          Er wordt geen bijkomende kost aangerekend indien u zich verzet tegen domiciliëring. U heeft de mogelijkheid om uw
          -afrekeningsfacturenen eindfactuur uit te sluiten van domiciliëring. De uitvoering van de domiciliëringsopdracht van de
          eindfactuur zal ten vroegste 15 kalenderdagen na datum van ontvangst van de eindfactuur gebeuren (de datum van ontvangst is de
          derde dag na het versturen van de factuur indien ze per post werd verstuurd en dezelfde dag als ze verstuurd werd per e-mail).
        </p>
        <p>
          9.3. De eventuele Terugleveringsvergoeding die Bolt u verschuldigd is voor de door u geïnjecteerde elektriciteit, wordt in onze
          afrekeningsfacturen en eindfactuur verrekend met de prijs die u aan Bolt verschuldigd bent voor de levering van de door u
          verbruikte elektriciteit. U betaalt het saldo aan Bolt of Bolt betaalt het saldo aan u, naargelang het geval.
        </p>
        <p>
          9.4. Indien u of wij van mening zijn dat onze factuur foutieve gegevens (andere dan de meetgegevens) bevat, moet binnen de 12
          maanden na ontvangst van de factuur schriftelijk contact met de andere partij worden opgenomen, behoudens wanneer de toepasselijke
          regelgeving een langere termijn voorziet. Indien de klacht over een factuur terecht is of verder moet worden onderzocht en indien
          de betreffende factuur nog niet werd betaald, mag u de betaling van het betwiste deel van de factuur opschorten tot de klacht is
          afgehandeld. Wij zullen zo vlug mogelijk na ontvangst van de klacht (of zo vlug mogelijk na ontvangst van de noodzakelijke
          informatie van een derde indien wij die informatie nodig hebben voor het beantwoorden van de klacht) ten gronde op de klacht
          antwoorden.
        </p>
        <p>
          9.5. Laattijdige betaling van één factuur door u heeft alsgevolg dat iedere andere factuur, ook al was daarvoor door ons een
          afbetalingsplan toegestaan, onmiddellijk opeisbaar is, zonder ingebrekestelling.
        </p>
        <p>
          9.6. Voor zover toegelaten door en overeenkomstig de toepasselijke regelgeving mogen wij administratieve kosten aanrekenen voor
          het toezenden van extra facturen, duplicaten, een afbetalingsplan, brieven ingevolge uw laattijdige betaling of indien een
          opdracht tot domiciliëring door de bank- en/of postinstelling wordt geweigerd. De kostprijs bedraagt tot 8 EUR voor een
          herinneringsbrief en 20 EUR voor een ingebrekestelling, behoudens wanneer de toepasselijke regelgeving andere bedragen voorziet.
        </p>
        <p>
          9.7. Bij niet-tijdige betaling van de gehele factuur of een deel ervan of indien een opdracht tot domiciliëring door de financiële
          instelling wordt geweigerd, bent u van rechtswege en zonder ingebrekestelling of herinnering gehouden tot betaling van
          verwijlinteresten. De verwijlinteresten worden berekend op basis van de wettelijke interestvoet als u een Consument bent en op
          basis en op basis van de interestvoet bepaald in de wet betreffende de bestrijding van de betalingsachterstand bij
          handelstransacties van augustus 2002 als u een Kleine Professionele Verbruiker bent. De verwijlinteresten worden aangerekend vanaf
          de vervaldag, op elk onbetaald gelaten bedrag tot de datum van volledige betaling. Daarenboven bent u, bij gebreke aan volledige
          betaling nadat wij uw onbetaalde factu(u)r(en) hebben overgemaakt aan een derde (bv. gerechtsdeurwaarder, advocaat of
          incassokantoor), van rechtswege en zonder verdere ingebrekestelling een forfaitaire schadeloosstelling verschuldigd van 10 % op
          elk onbetaald gelaten factuurbedrag, met een minimum van 55 EUR, dit ter vergoeding van de buitengerechtelijke invorderingskosten,
          in overeenstemming met de toepasselijke regelgeving, onverminderd ons recht om grotere schade en nadelen te bewijzen, onder meer
          door aanrekening van procedurekosten.
        </p>
        <p>
          9.8. Tenzij de gewestelijke reglementering een andere schadevergoeding zou voorzien, heeft u recht op verwijlinteresten op elk
          onbetaald gelaten bedrag aan de wettelijke interestvoet ingevolge foutieve facturatie door onze fout of onze laattijdige
          (terug)betaling. Deze interesten beginnen te lopen de dag na de dag waarop wij de betaling conform artikel 9.2 hadden moeten
          uitvoeren, of, in geval van foutieve facturatie door onze fout, vanaf de datum van protest door u, tot de datum van volledige
          betaling door ons. Tevens zijn dan de kosten van uw ingebrekestellingen en herinneringen voor onze rekening. Daarenboven heeft u
          recht op een forfaitaire schadeloosstelling van 10% van het dan onbetaalde bedrag voor zover u een derde (bv. gerechtsdeurwaarder,
          advocaat of incassokantoor) moet inschakelen om betaling ervan te bekomen met een minimum van 55 EUR, dit ter vergoeding van de
          buitengerechtelijke invorderingskosten, in overeenstemming met de toepasselijke regelgeving, onverminderd uw recht om grotere
          schade en nadelen te bewijzen, onder meer door aanrekening van procedurekosten.
        </p>
        <p>9.9. Indien de Leveringsovereenkomst wordt beëindigd, om welke reden ook, bezorgen wij u een eindafrekening.</p>
        <p>
          9.10. Indien u meent recht te hebben op het statuut van beschermde klant of op het sociaal tarief en dit niet automatisch wordt
          toegepast, moet u ons zo snel als mogelijk de nodige bewijzen en stukken bezorgen.
        </p>
        <h3>10. Aansprakelijkheid</h3>
        <p>
          10.1. Zonder afbreuk te doen aan de overige bepalingen inzake aansprakelijkheid in deze Leveringsovereenkomst en/of
          Terugleveringsovereenkomst en in de toepasselijke regelgeving, zijn u en wij ten opzichte van elkaar enkel aansprakelijk in geval
          van: (a) niet-uitvoering van de voornaamste verbintenissen van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst,
          tenzij in geval van overmacht; (b) bedrog, grove of opzettelijke fout; (c) overlijden of lichamelijk letsel van u veroorzaakt door
          een handeling of nalaten van Bolt.
        </p>
        <p>
          10.2. In geval van aansprakelijkheid zal enkel de rechtstreeks veroorzaakte materiële schade vergoed worden. Enige vergoeding van
          immateriële schade zoals onder andere bedrijfsschade, winstderving, productieverlies, verlies van gegevens of verlies van
          inkomsten is uitdrukkelijk uitgesloten. De vergoeding van alle materiële schade zal bovendien maximaal gelijk zijn aan 12 maal uw
          gemiddelde maandverbruik van de laatste zes maanden, of van de duur van de Leveringsovereenkomst en/of Terugleveringsovereenkomst
          zo deze korter is. Deze beperking is niet van toepassing in geval van overlijden of lichamelijk letsel van u veroorzaakt door een
          handeling of nalaten van Bolt.
        </p>
        <p>
          10.3. Elke aanspraak op schadevergoeding moet binnen 30 kalenderdagen na de datum waarop de schade is ingetreden of na de datum
          waarop de schade redelijkerwijs vastgesteld had kunnen worden, schriftelijk aan de andere partij worden gemeld. Laattijdige
          schademeldingen worden niet vergoed.
        </p>
        <p>
          10.4. Wij zijn niet aansprakelijk voor de schade veroorzaakt door het niet goed functioneren van het net, de installaties op het
          Leverpunt, de meetinrichting, fouten in meetgegevens, variaties in spanning en frequentie, tekortkomingen van de Netbeheerder,
          noch voor de gevolgen van het niet-nakomen van de afspraken tussen u en de Netbeheerder. Evenmin zijn wij aansprakelijk voor de
          kwaliteit van de uitgewisselde gegevens (zoals bijvoorbeeld standaard jaarverbruiken, synthetische lastprofielen). Dit alles is de
          verantwoordelijkheid van de Netbeheerder en staat los van de Leveringsovereenkomst en/of Terugleveringsovereenkomst.
        </p>
        <p>10.5. U zal ons vrijwaren voor eventuele vorderingen van derden, zoals uw commerciële relaties.</p>
        <h3>
          11. Schorsing van de Levering en/of Teruglevering en onmiddellijke beëindiging van de Leveringsovereenkomst en/of
          Terugleveringsovereenkomst
        </h3>
        <p>
          11.1. In geval van ernstige tekortkoming door ons, mag u de Leveringsovereenkomst en/of Terugleveringsovereenkomst vroegtijdig
          beëindigen per aangetekende brief met onmiddellijke ingang en zonder rechterlijke tussenkomst.
        </p>
        <p>
          11.2. Wij mogen de Levering en/of de Teruglevering schorsen of de Leveringsovereenkomst en/of de Terugleveringsovereenkomst
          vroegtijdig beëindigen per schriftelijke kennisgeving met onmiddellijke ingang, zonder rechterlijke tussenkomst en zonder
          schadevergoeding, mits naleving van de toepasselijke regelgeving, indien:
        </p>
        <ol type="a">
          <li>u uw betalingsverplichtingen of andere verplichtingen na ingebrekestelling niet nakomt;</li>
          <li>wij u conform artikel 4.3 vragen om een waarborg te stellen, en u nalaat om (tijdig) deze waarborg te stellen;</li>
          <li>
            er een onderbreking of stopzetting van de Levering en/of de Teruglevering wordt opgelegd door de Netbeheerder of een bevoegde
            overheid;
          </li>
          <li>u fraudeert of door ons geleverde elektriciteit en/of aardgas doorlevert aan derden;</li>
          <li>
            u nalaat ons onmiddellijk in te lichten over ieder element waarvan u kennis heeft dat de uitvoering van de Leveringsovereenkomst
            en/of de Terugleveringsovereenkomst kan verhinderen of bemoeilijken.
          </li>
        </ol>
        <p>
          De beëindiging doet geen afbreuk aan ons recht op schadevergoeding. In geval van beëindiging overeenkomstig artikel 11.2 (d), zal
          deze schadevergoeding minstens gelijk zijn aan 3 maanden geschat verbruik. Indien onze schade groter is, zullen wij ook die kunnen
          verhalen. Onverminderd hetgeen bepaald is in artikel 9.5 en 9.6, bent u evenwel geen schadevergoeding verschuldigd indien wij
          beëindigen op grond van artikel 11.2. (a), (b) of (c).
        </p>
        <p>
          11.3. In geval van een vroegtijdige beëindiging van de Leveringsovereenkomst door u of door ons, wordt de Leveringsovereenkomst
          steeds in zijn geheel beëindigd, m.a.w. voor zowel elektriciteit als voor aardgas. Desgevallend kan er daarna een nieuwe
          Leveringsovereenkomst worden gesloten voor elektriciteit of aardgas.
        </p>
        <p>
          11.4. Wanneer de Terugleveringsovereenkomst, al dan niet vroegtijdig, wordt beëindigd door u of door ons, heeft dit geen impact op
          de Leveringsovereenkomst, tenzij anders aangegeven door u of door ons. Wanneer de Terugleveringsovereenkomst, al dan niet
          vroegtijdig, wordt beëindigd door u of door ons, wordt de Leveringsovereenkomst ook beëindigd.
        </p>
        <p>
          11.5 De Leveringsovereenkomst loopt in alle gevallen door zolang Bolt in het toegangsregister vermeld staat als de
          verantwoordelijke voor de bevoorrading op uw Leverpunt.
        </p>
        <h3>12. Verhuis / overdracht</h3>
        <p>
          12.1. Bij verhuis blijft de Leveringsovereenkomst onverminderd van kracht op uw nieuwe adres. U dient ons bij voorkeur 30
          kalenderdagen op voorhand (en uiterlijk 30 kalenderdagen na de verhuisdatum voor Consumenten en 10 kalenderdagen erna voor Kleine
          Professionele Verbruikers) op de hoogte te brengen van uw verhuisplannen en ons volgende informatie te bezorgen:
        </p>
        <ol type="a">
          <li>uw toekomstige adres;</li>
          <li>EAN-nummer(s) en meternummer op dat adres;</li>
          <li>
            de datum vanaf wanneer er geleverd moet worden op het nieuwe Leverpunt en de Levering op uw huidige Leverpunt gestopt dient te
            worden; en de meterstanden van uw oude en nieuwe adres op het ogenblik van de verhuisdatum.
          </li>
        </ol>
        <p>
          U kan hiervoor gebruik maken van de communicatiekanalen die wij met het oog op verhuis ter beschikking stellen, o.a. ons
          energieovernamedocument.
        </p>
        <p>
          12.2. Indien u ons niet binnen de termijn bepaald in artikel 12.1 op de hoogte stelt van uw verhuis, blijft de
          Leveringsovereenkomst gelden op uw oude adres. Dit betekent dat u gehouden bent om alle elektriciteit en/of aardgas moet betalen
          die – door wie dan ook - wordt afgenomen op het Leverpunt dat u verlaat, tenzij de toepasselijke regelgeving in een andersluidende
          dwingende regeling voorziet. Indien u ons niet binnen de termijn bepaald in artikel 12.1 op de hoogte stelt van uw verhuis, neemt
          de Terugleveringsovereenkomst automatisch een einde op het moment van uw verhuis. Eventuele elektriciteit die – door wie dan ook –
          wordt geïnjecteerd op het Leverpunt dat u verlaat, wordt niet vergoed door Bolt, tenzij de toepasselijke regelgeving in een
          andersluidende dwingende regeling voorziet.
        </p>
        <p>
          12.3. Wij bezorgen u een factuur met de eindafrekening voor het Leverpunt dat u verlaat. Indien u ons niet binnen de termijn
          bepaald in artikel 12.1 de meterstand van het Leverpunt dat u verlaat, bezorgt, dan hebben wij het recht om de meterstand te laten
          vaststellen door de Netbeheerder op uw kosten.
        </p>
        <p>
          12.4. Indien u, mits voorlegging van het bewijs, verhuist naar het buitenland of naar een ander gewest, naar een woning waar er
          geen aparte meter is voor elektriciteit- en/of aardgasverbruik, gaat inwonen bij een andere verbruiker die reeds een
          leveringsovereenkomst (met ons of met een andere leverancier) heeft, verhuist naar een gebied waar wij om objectieve redenen niet
          (meer) in staat zijn om de Leveringsovereenkomst en/of de Terugleveringsovereenkomst verder te zetten, kan de
          Leveringsovereenkomst en/of de Terugleveringsovereenkomst door u of door ons opgezegd worden met ingang van de effectieve
          verhuisdatum.
        </p>
        <p>
          12.5. Wij leveren op uw nieuwe Leverpunt vanaf de datum die u ons meedeelde. De BV van de Leveringsovereenkomst en/of de
          Terugleveringsovereenkomst kunnen worden aangepast zoals voorzien in artikel 13 en/of in functie van uw nieuwe Netbeheerder.
        </p>
        <p>
          12.6. Indien u de bovenstaande verplichtingen bij uw verhuis niet naleeft, geeft u ons een mandaat om bij de netbeheerder de
          sluiting van de meter op het Leverpunt dat u verlaat, te vragen. U staat dan in voor alle kosten van de sluiting. Wij zijn niet
          aansprakelijk voor de schade die in dat geval wordt veroorzaakt.
        </p>
        <h3>13. Wijzigingen aan de Leveringsovereenkomst en/of Terugleveringsovereenkomst</h3>
        <p>
          13.1. Voor zover deze wijzigingen niet in uw nadeel zijn, mogen wij op elk moment wijzigingen aanbrengen aan de
          Leveringsovereenkomst en/of de Terugleveringsovereenkomst. Wij zullen u desgevallend deze gewijzigde voorwaarden ten minste twee
          maanden voor het inwerkingtreden ervan op geïndividualiseerde wijze meedelen. Als mededeling geldt onder meer de melding per
          brief, op de factuur, per e-mail of via een andere duurzame drager.
        </p>
        <p>
          13.2. Indien uw Leveringsovereenkomst en/of uw Terugleveringsovereenkomst van onbepaalde duur is, kunnen wij bovendien op elk
          moment:
          <br />
          - prijsverhogingen doorvoeren in het geval van een Leveringsovereenkomst;
          <br />
          - de Terugleveringsvergoeding verlagen in het geval van een Terugleveringsovereenkomst;f
          <br />
          - of wijzigingen in uw nadeel aanbrengen
          <br />
          mits wij u hiervan minstens twee maanden voor het inwerkingtreden ervan informeren op dezelfde wijze als bepaald in artikel 13.1.
        </p>
        <p>
          U zal geacht worden deze wijzigingen aanvaard te hebben, tenzij u binnen de maand na ontvangst van de mededeling de
          Leveringsovereenkomst (in geval van wijzigingen aan de Leveringsovereenkomst) en/of de Terugleveringsovereenkomst (in geval van
          wijzigingen aan de Terugleveringsovereenkomst) opzegt conform artikel 6.3. In geval van mededeling per e-mail, is de dag van
          ontvangst de dag van verzending van de e-mail; indien de mededeling wordt verstuurd per post, wordt deze geacht te zijn ontvangen
          op de derde dag na de verzending.
        </p>
        <p>
          13.3. Indien uw Leveringsovereenkomst wordt verlengd overeenkomstig artikel 6.2, kunnen wij u evenwel twee maanden vóór de
          verlenging voorstellen om de prijzen en/of voorwaarden van de Leveringsovereenkomst voor de volgende periode te wijzigen. Indien u
          schriftelijk instemt met de wijzigingen, zal de Leveringsovereenkomst voor de volgende periode worden voortgezet volgens deze
          wijzigingen. Indien u dit niet doet en u ook niet van leverancier bent veranderd bij afloop van de lopende duur, zullen wij u
          blijven leveren aan de prijzen en voorwaarden van ons goedkoopste equivalent product van bepaalde duur.
        </p>
        <p>
          13.4. Indien uw Terugleveringsovereenkomst wordt verlengd overeenkomstig artikel 6.2, kunnen wij u evenwel twee maanden vóór de
          verlenging voorstellen om de prijzen en/of voorwaarden van de Terugleveringsovereenkomst voor de volgende periode te wijzigen.
          Indien u schriftelijk instemt met de wijzigingen, zal de Terugleveringsovereenkomst voor de volgende periode worden voortgezet
          volgens deze wijzigingen. Indien u dit niet doet en u ook geen andere leverancier of derde hebt aangeduid als koper van de door uw
          geïnjecteerde elektriciteit, heeft Bolt de keuze om de Terugleveringsovereenkomst te verlengen aan de oude prijzen en voorwaarden
          dan wel om de Terugleveringsovereenkomst niet te verlengen.
        </p>
        <p>
          13.5. Indien, anders dan in artikel 13.1 en 13.2, de Bijzondere Voorwaarden in onderling overleg worden gewijzigd, zal een nieuwe
          Leveringsovereenkomst en/of Terugleveringsovereenkomst tot stand komen zodra wij deze wijziging in onze systemen hebben verwerkt.
          Wij brengen u van deze datum op de hoogte.
        </p>
        <p>
          13.6. Wij mogen de Leveringsovereenkomst en/of de Terugleveringsovereenkomst overdragen aan een derde en zullen u in dat geval
          inlichten. Deze derde zal de Leveringsovereenkomst en/of de Terugleveringsovereenkomst onder dezelfde voorwaarden verder zetten. U
          mag de Leveringsovereenkomst en/of de Terugleveringsovereenkomst niet overdragen aan een derde, een medebewoner of een nieuwe
          bewoner.
        </p>
        <h3>14. Wijziging Producent Elektriciteit</h3>
        <p>
          14.1. De koppeling tussen u en de Producent Elektriciteit is gebaseerd op gemiddelden van uw verbruik en de productie van de
          Producent Elektriciteit. Beperkte schommelingen in uw verbruik en de productie van de Producent Elektriciteit zullen worden
          opgevangen met elektriciteit afkomstig van andere producenten die bij ons platform zijn aangesloten, die eveneens lokale en groene
          elektriciteit produceren.
        </p>
        <p>
          14.2. Indien de Producent Elektriciteit niet meer beschikbaar is op ons platform of structureel niet meer voldoende elektriciteit
          produceert om in uw elektriciteitsverbruik te voorzien (naast dat van de andere klanten die voor deze Producent Elektriciteit
          hebben gekozen), zal Bolt u hiervan schriftelijk op de hoogte brengen per brief of per e-mail. Wij stellen u dan een nieuwe
          producent voor ter vervanging van uw Producent Elektriciteit. Vanaf deze melding, beschikt u over één maand om ons een andere
          keuze voor een nieuwe producent mee te delen via brief of e-mail. Deze termijn van één maand gaat in vanaf de dag van verzending
          van onze e-mail of vanaf de derde dag na de verzending van onze brief. Indien u ons uw keuze voor een andere nieuwe producent niet
          meedeelt en u ook niet van leverancier verandert binnen deze termijn, zullen wij de door ons voorgestelde producent aan u
          koppelen.
        </p>
        <p>
          14.3. De wijziging van de Producent Elektriciteit overeenkomstig artikel 14.2., zal niet worden beschouwd als een wijziging van de
          Leveringsovereenkomst.
        </p>
        <h3>15. Evenwichtsverantwoordelijkheid</h3>
        <p>
          Voor de evenwichtsverantwoordelijkheid, zowel voor de Levering als voor de Teruglevering, doet Bolt een beroep op [Luminus NV].
        </p>
        <h3>16. Overmacht</h3>
        <p>
          16.1. Ingeval van overmacht worden de verplichtingen onder deze Leveringsovereenkomst en/of Terugleveringsovereenkomst, behalve de
          verplichting tot betaling van een geldsom, geschorst of beperkt gedurende de periode van de overmacht. Onder overmacht dient te
          worden verstaan: elke onvoorzienbare en onvermijdbare gebeurtenis die onafhankelijk is van de wil van een partij die een
          onoverkomelijk beletsel uitmaakt voor de nakoming van de verbintenis van die partij, zoals maar niet beperkt tot, uitval van het
          net, problemen in het transport of de distributie, het niet kunnen verkrijgen van (voldoende) elektriciteit of aardgas,
          natuurrampen, stakingen.
        </p>
        <p>
          16.2. Indien de overmachtssituatie meer dan drie maanden aanhoudt, hebben zowel u als wij het recht om de Leveringsovereenkomst
          en/of Terugleveringsovereenkomst schriftelijk te beëindigen, zonder dat schadevergoeding verschuldigd is aan de andere partij.
        </p>
        <h3>17. Bescherming van de persoonlijke levenssfeer</h3>
        <p>
          Als verantwoordelijke voor de verwerking van uw persoonsgegevens, verwerken wij uw persoonsgegevens steeds in overeenstemming met
          de toepasselijke privacyregelgeving. Wij verwerken uw persoonsgegevens voor doeleinden en rechtsgronden beschreven in ons
          privacybeleid zoals vermeld op onze website www.boltenergie.be onder de rubriek “Disclaimer en Privacy Policy” (hierna ‘het
          Privacybeleid’). Door uitdrukkelijk in te stemmen en akkoord te gaan met de Leveringsovereenkomst en/of
          Terugleveringsovereenkomst, bevestigt u kennis te hebben genomen van het Privacybeleid en akkoord te gaan met de verwerking van uw
          persoonsgegevens overeenkomstig het Privacybeleid.
        </p>
        <h3>18. Geen afstand van recht</h3>
        <p>
          Het niet-aandringen op de uitvoering van enige bepaling van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst, kan niet
          worden opgevat als een afstand van recht of een beperking daarvan.
        </p>
        <h3>19. Onafdwingbare bepalingen</h3>
        <p>
          Indien een bepaling van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst ongeldig of nietig zou zijn, zal dit geen
          invloed hebben op de geldigheid van de andere bepalingen van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst, maar
          zal deze ongeldige of nietige bepaling naar best vermogen vervangen worden door een geldige bepaling die zo nauw mogelijk aansluit
          bij de oorspronkelijke bedoeling van de partijen.
        </p>
        <h3>20. Toepasselijk recht en geschillen – klachten</h3>
        <p>20.1. Het Belgisch recht is van toepassing op de Leveringsovereenkomst en/of de Terugleveringsovereenkomst.</p>
        <p>
          20.2. Voor klachten kan u zich wenden tot onze klantendienst, waarvan u de contactgegevens kan terugvinden op uw factuur of op
          onze website. Indien uw Leveringsovereenkomst en/of Terugleveringsovereenkomst elektronisch werd afgesloten, kan u beroep doen op
          het ODR-platform voor onlinebeslechting van uw geschillen (
          <a href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a>).
        </p>
        <p>
          20.3. Geschillen omtrent de Leveringsovereenkomst en/of de Terugleveringsovereenkomst kunnen naar keuze van de eisende partij
          worden gebracht voor de rechter van de woonplaats van de verwerende partij of voor de rechter van de plaats waar de verbintenis
          waarop het geschil betrekking heeft, is ontstaan of waar zij moet worden uitgevoerd.
        </p>
        <h3>MODELFORMULIER HERROEPING</h3>
        <p>
          Dit formulier alleen invullen en aan Bolt bezorgen als je je Leveringsovereenkomst en/of je Terugleveringsovereenkomst wil
          herroepen.
        </p>
        <p>Gelieve dit document terug te bezorgen aan Bolt:</p>
        <p>Via post: (adres aanvullen)</p>
        <p>Via e-mail: (e-mail aanvullen)</p>
        <p>
          Ik deel u mee dat ik de Leveringsovereenkomst voor de levering van elektriciteit / gas en/of de Terugleveringsovereenkomst voor
          elektriciteit* wil herroepen. (Schrappen wat niet past).
        </p>
        <p>Productnaam:</p>
        <p>Datum bevestiging Leveringsovereenkomst en/of Terugleveringsovereenkomst:</p>
        <p>
          <i>
            In het geval de Leveringsovereenkomst en/of Terugleveringsovereenkomst telefonisch gesloten werd: de datum dat u de
            Leveringsovereenkomst en/of Terugleveringsovereenkomst bevestigd heeft.
          </i>
        </p>
        <p>
          <i>In alle andere gevallen: de datum dat Bolt de Leveringsovereenkomst en/of Terugleveringsovereenkomst bevestigd heeft.</i>
        </p>
        <p>Naam Consument:</p>
        <p>Adres Consument:</p>
        <p>Datum:</p>
        <p>Handtekening:</p>
      </div>
    )
  }

  const renderFrench = () => {
    return (
      <div className={styles.terms}>
        <h2>
          Conditions générales pour la fourniture d’électricité et/ou de gaz naturel par Bolt Energie S.P. (ci-après « nous ») au client
          (ci-après « vous ») et la restitution d’électricité _ 01-02-21
        </h2>
        <h3>1. Les définitions et applications des Conditions générales (ci-après « CG »)</h3>
        <p>
          <strong>Conditions particulières</strong> : notre document dans lequel le prix, la durée et les dispositions particulières du
          Contrat de fourniture et/ou du Contrat de restitution sont mentionnés (ci-après « CP »).
          <br />
          <strong>Consommateur</strong> : toute personne physique qui achète de l’électricité et/ou de gaz naturel à des fins qui n’entrent
          pas dans le cadre de son activité commerciale, industrielle, artisanale ou professionnelle, sauf disposition contraire de la
          réglementation applicable.
          <br />
          <strong>Petit consommateur professionnel</strong> : toute personne physique ou morale qui achète de l’électricité et/ou du gaz
          naturel partiellement ou exclusivement à des fins professionnelles, et dont la consommation annuelle pour l’ensemble de ses Points
          de fourniture est inférieure à 50 MWh d’électricité et à 100 MWh de gaz naturel pour les contrats conclus, modifiés ou renouvelés
          avant le 1er septembre 2021, et inférieure à 100 MWh d’électricité et/ou à 100 MWh de gaz naturel pour les contrats conclus,
          modifiés ou renouvelés à partir du 1er septembre 2021.
          <br />
          <strong>Fourniture</strong> : la fourniture au Point de fourniture d’électricité et/ou de gaz naturel.
          <br />
          <strong>Contrat de fourniture</strong> : l’ensemble du contrat entre vous et nous concernant la Fourniture : les CG, les CP ainsi
          que tout complément ou adaptation de ceux-ci par écrit font partie de ce Contrat de fourniture ; en cas de contradiction, les CP
          ont la priorité.
          <br />
          <strong>Point de fourniture</strong> : le point convenu où nous fournissons l’électricité et/ou le gaz naturel et où vous
          restituez le cas échéant l’électricité à Bolt ; ce point à un numéro EAN unique.
          <br />
          <strong>Gestionnaire de réseau</strong> : le gestionnaire du réseau national, régional ou local de transmission, de transport ou
          de distribution de l’électricité et/ou du gaz naturel.
          <br />
          <strong>Tarifs du réseau</strong> : les tarifs pour l’utilisation du réseau de distribution, de transmission ou de transport
          d’électricité et/ou de gaz.
          <br />
          <strong>Producteur d'électricité</strong> : le producteur d’électricité verte et locale proposé par Bolt et choisi par vous.
          <br />
          <strong>Restitution</strong> : la vente à Bolt d’électricité produite par le client et injectée au Point de fourniture.
          <br />
          <strong>Contrat de restitution</strong> : ll’ensemble du contrat entre vous et nous concernant la Restitution : les CG, les CP
          ainsi que tout complément ou adaptation de ceux-ci par écrit font partie de ce Contrat de fourniture et/ou de restitution ; en cas
          de contradiction, les CP ont la priorité.
          <br />
          <strong>Frais de restitution</strong> : la compensation payée par Bolt au client pour l’électricité produite par lui et injectée
          au Point de fourniture.
        </p>
        <p>
          Les termes qui ne sont pas définis dans le présent Contrat de fourniture et/ou le Contrat de restitution ont la signification
          telle que déterminée dans la législation en vigueur (en ce compris, les règlements techniques). Pour plus d'explication sur les
          législations régionales, nous référons aux sites Web des régulateurs compétents.
        </p>
        <p>
          Les présentes CG sont d'application à la fourniture d'électricité et de gaz naturel aux Consommateurs et aux Petits consommateurs
          professionnels. En signant le Contrat de fourniture, vous acceptez les présentes CG.
        </p>
        <h3>2. Contrat de fourniture</h3>
        <p>
          2.1. Nous fournirons l'électricité et/ou le gaz naturel tel que déterminé dans le Contrat de fourniture. Vous prélèverez notre
          électricité et/ou gaz naturel au Point de fourniture, vous nous payerez le prix convenu et vous respecterez les autres
          dispositions du Contrat de fourniture. Le Contrat de fourniture ne porte pas préjudice aux dispositions légales portant, entre
          autres, sur les missions de service public.
        </p>
        <p>
          2.2. Si nous ne disposons pas d'une quantité suffisante d'énergie durable issue de sources renouvelables en raison d'un cadre
          réglementaire modifié ou d'autres circonstances qui sont hors de notre contrôle, nous pouvons compléter la fourniture avec
          d'autres énergies toutefois aussi durables que possible.
        </p>
        <h3>3. Contrat de restitution</h3>
        <p>
          3.1. Vous ne pouvez conclure un Contrat de restitution avec Bolt que si vous avez également un Contrat de fourniture avec Bolt et
          que vous disposez d’un compteur numérique au Point de fourniture. Un compteur numérique mesure séparément votre achat et votre
          injection d’électricité, et peut être relevé à distance.
        </p>
        <p>
          3.2. Si nous concluons un Contrat de restitution, Bolt vous paiera un montant pour l’électricité que vous produisez et injectez au
          Point de fourniture. Ce montant est déterminé dans les CP.
        </p>
        <h3>4. Conclusion du Contrat de fourniture et/ou du Contrat de restitution</h3>
        <p>
          4.1. Le Contrat de fourniture et/ou le Contrat de restitution est élaboré dès que vous avez accepté notre offre et sous la
          condition suspensive de confirmation, par le gestionnaire de réseau, de vos coordonnées.
        </p>
        <p>
          4.2. Si le Contrat de fourniture et/ou le Contrat de restitution avec vous est conclu à distance (p.ex. via notre site Web ou par
          téléphone) ou en dehors des locaux de vente de notre entreprise (p.ex. sur des événements, via le porte-à-porte) et que vous êtes
          Consommateur, le Contrat de fourniture vous sera confirmé par écrit (par courrier ou par mail).
        </p>
        <p>
          4.3. Dans la mesure autorisée et conformément à la législation en vigueur, nous pouvons vous refuser en tant que client si nous
          avons des raisons objectives de douter de votre solvabilité. En outre, nous avons le droit, dans la mesure autorisée et
          conformément à la législation en vigueur, de vous demander une garantie dans les cas suivants :
        </p>
        <ol type="a">
          <li>vous avez un arriéré de dettes chez nous (auquel cas vous devez d'abord vous acquitter de ces dettes) ; et/ou</li>
          <li>
            vous n'avez pas, au cours de la période de 24 mois précédant la conclusion du Contrat de fourniture ou pendant la durée du
            Contrat de fourniture, payé deux ou plusieurs factures dans les délais.
          </li>
        </ol>
        <p>
          Si vous ne donnez pas suite à la demande de garantie dans un délai de 15 jours calendrier, nous pouvons également vous refuser
          comme client.
        </p>
        <p>
          La garantie correspondra au maximum à 3 mois de consommation estimée et nous pourrons l'utiliser pour le remboursement de vos
          dettes. Après remboursement éventuel des montants impayés, conformément à la législation en vigueur, la garantie sera reversée
          dans les 30 jours calendrier suivant notre facture de clôture. Dans tous les cas, vous pouvez demander la restitution de la
          garantie dès que vous avez payé toutes vos factures dans les délais, sans rappel de paiement pendant une période d’un an et dès
          que vous n’avez plus de dettes à notre égard, sauf indication contraire dans la loi.
        </p>
        <p>
          4.4. La Fourniture et/ou la Restitution commence dès que nous avons été enregistrés par le Gestionnaire du réseau comme
          fournisseur pour le Point de fourniture et/ou, en cas de Restitution, comme acheteur de l’électricité injectée par le client au
          Point de fourniture dans le registre de raccordement ou le registre d’accès. Si vous êtes Consommateur et que le Contrat de
          fourniture et/ou de restitution a été conclu à distance ou en dehors des locaux de vente de notre entreprise ou de nos
          partenaires, la Fourniture et/ou la Restitution débutera au plus tôt après le délai de rétractation, sauf si vous nous demandez
          expressément de déjà commencer la fourniture d'électricité et/ou de gaz naturel pendant le délai de rétractation prévu à l'article
          5.1.
        </p>
        <p>
          4.5. Les Consommateurs qui sont encore liés par un Contrat de fourniture et/ou un Contrat de restitution ayant trait au Point de
          fourniture avec un autre fournisseur au moment de la conclusion du Contrat de fourniture et/ou de restitution nous donnent mandat
          exprès de résilier ce contrat de fourniture en leur nom et pour leur compte. Les clients qui sont encore liés par un contrat de
          restitution avec une autre partie que le fournisseur (comme un agrégateur) font le nécessaire pour résilier ce contrat et en
          fournir la preuve à Bolt.
        </p>
        <h3>5. Droit de rétractation</h3>
        <p>
          5.1. Si vous êtes un Consommateur, vous avez le droit de renoncer au présent Contrat de fourniture et/ou de restitution, sans
          paiement d’une amende et sans mention de motif, et ce, dans un délai de rétractation expirant 14 jours calendrier à partir de la
          réception de la confirmation du Contrat de fourniture et/ou de restitution par Bolt, ou si le Contrat de fourniture et/ou de
          restitution a été conclu par téléphone, à compter de la date de confirmation du Contrat de fourniture et/ou de restitution par
          vous-même. Pour exercer ce droit de rétractation, vous devez informer Bolt de cette décision au moyen d’une déclaration claire
          (p.ex., par courrier, fax ou e-mail). Vous pouvez pour cela utiliser le modèle de formulaire de rétractation annexé aux présentes
          CG et que vous pouvez également télécharger sur notre site Web www.boltenergie.be.
        </p>
        <p>
          5.2. Si vous avez demandé le lancement de la fourniture d’électricité et/ou de gaz naturel pendant le délai de rétractation, vous
          payez une somme proportionnelle au volume fourni au moment où vous nous notifiez votre rétractation du Contrat de fourniture. Si
          vous avez choisi de faire commencer votre Contrat de restitution pendant la période de rétractation, Bolt vous paiera une
          redevance pour l’électricité que vous avez injectée au Point de fourniture à partir de la date de début du Contrat de restitution
          jusqu’au moment où vous nous notifierez la rétractation du Contrat de restitution.
        </p>
        <h3>6. Durée</h3>
        <p>
          6.1. Le Contrat de fourniture et/ou de restitution est conclu pour une durée déterminée ou indéterminée. Les CP mentionnent si
          votre Contrat de fourniture et/ou de restitution est à durée déterminée ou indéterminée.
        </p>
        <p>
          6.2. Si votre Contrat de fourniture et/ou de restitution est à durée déterminée, il sera en principe automatiquement prolongé pour
          la durée mentionnée dans les CP, sauf indication contraire dans les CP. Nous pouvons vous informer au moins deux mois avant
          l’échéance de la durée en cours que nous ne souhaitons pas prolonger le Contrat de fourniture et/ou de restitution. Nous pouvons
          toutefois, à cette occasion, vous faire parvenir une nouvelle proposition de contrat de fourniture et/ou de restitution. Vous
          pouvez également renoncer vous-même à la prolongation en nous en informant par écrit (par courrier ou par e-mail) au moins un mois
          avant l’échéance de la durée en cours.
        </p>
        <p>
          6.3. Vous pouvez à tout moment résilier votre Contrat de fourniture et/ou de restitution gratuitement par écrit (par courrier ou
          par e-mail) moyennant un préavis d’au moins un mois. La fermeture du Point de fourniture ou la notification de la modification de
          fournisseur via le Gestionnaire de réseau est considérée, pour ce Point de fourniture, comme résiliation du Contrat de fourniture
          et/ou de restitution par vous-même.
        </p>
        <p>
          6.4. Nous pouvons résilier le Contrat de fourniture et/ou de restitution à durée indéterminée à tout moment moyennant un préavis
          de deux mois.
        </p>
        <p>
          6.5. Le Contrat de fourniture est dans les tous cas maintenu tant que Bolt est mentionné dans le registre d’accès en tant que
          responsable de l'approvisionnement de votre Point de fourniture.
        </p>
        <h3>7. Consommation, fourniture et mesures</h3>
        <p>7.1. Consommation</p>
        <p>
          7.1.1. Vous consommerez l’électricité et/ou le gaz naturel uniquement au Point de fourniture et vous vous abstiendrez de les
          fournir à des tiers.
        </p>
        <p>
          7.1.2. Si vous utilisez des appareils pour produire vous-même de l’énergie, vous êtes tenu de nous le signaler sans délai. Si vous
          le souhaitez, vous pouvez conclure un Contrat de restitution avec Bolt pour l’électricité injectée par vous dans le réseau.
        </p>
        <p>7.2. Fourniture et Gestionnaire de réseau</p>
        <p>
          7.2.1. Vous concluez avec nous le Contrat de fourniture et/ou le Contrat de restitution. Votre raccordement au réseau est géré par
          le Gestionnaire de réseau. Le Gestionnaire de réseau est responsable du fonctionnement du réseau ainsi que de la continuité de la
          Fourniture et la Restitution, il règle la qualité du prélèvement, l’arrivée d’électricité et/ou de gaz naturel, l’équipement de
          mesure et les dispositions techniques pertinentes pour le raccordement des installations ainsi que le raccordement et la fermeture
          de compteurs. Nous ne sommes pas partie à cette relation et ne sommes dès lors pas responsables du respect des règles applicables
          à cette relation par vous-même ou par le Gestionnaire de réseau.
        </p>
        <p>
          7.2.2. Si le Gestionnaire de réseau limite ou interrompt l’arrivée d’électricité et/ou de gaz naturel et/ou l'injection
          d’électricité dans le réseau, la Fourniture et/ou la Restitution sera également automatiquement limitée ou interrompue. Cette
          limitation et/ou interruption ne relève pas de notre responsabilité.
        </p>
        <p>7.3. Mesures</p>
        <p>
          7.3.1. Le Gestionnaire de réseau nous communique le relevé de votre compteur. Si vous nous communiquez le relevé, vous êtes
          responsable de son indication correcte. Dans tous les cas, les données du Gestionnaire du réseau ont la priorité.
        </p>
        <p>
          7.3.2. Tant vous que nous pouvons, en cas de doute quant à l’exactitude du relevé, faire examiner l'installation de mesure. Cette
          opération est effectuée aux frais du demandeur.
        </p>
        <p>
          7.3.3. Une rectification des mesures et de la facturation en résultant peut concerner une période de deux ans au maximum avant le
          dernier relevé, sauf stipulation contraire de la loi.
        </p>
        <h3>8. Prix et frais</h3>
        <p>
          8.1. Le prix dont vous êtes redevable à l'égard de Bolt pour la Fourniture comprend (1) le prix de l’énergie tel que déterminé
          dans les CP et (2) les autres éléments constitutifs du prix prescrits par l'article 8.2.
        </p>
        <p>8.2. Sauf stipulation contraire dans les CP, le prix de l'énergie est majoré de :</p>
        <ul>
          <li>
            la TVA, les taxes, redevances, cotisations, suppléments, indemnités et autres charges éventuelles qui nous sont imposés par les
            autorités ou instances de régulation compétentes ;
          </li>
          <li>
            les tarifs nets, les frais de location de compteur, les frais de raccordement ou de fermeture du Point de fourniture, les
            services de réseau supplémentaires éventuels, la puissance réactive et la puissance de pointe qui nous sont imposés par le
            Gestionnaire de réseau.
          </li>
          <li>
            Les frais résultant des obligations légales de produire des certificats verts, chaleur verte, cogénération et/ou des certificats
            analogues.
          </li>
        </ul>
        <p>
          Ces éléments constitutifs, y compris les modifications qui n'incombent pas à Bolt, vous sont facturé directement, et ce, avec
          effet rétroactif.
        </p>
        <p>
          8.3. Nous pouvons vous facturer tous les frais qui nous sont facturés par le Gestionnaire de réseau pour des services effectués à
          votre demande, à l’initiative du Gestionnaire de réseau ou à notre demande suite à une faute ou une négligence de votre part. Nous
          pouvons également vous facturer nos frais administratifs en plus de ces frais.
        </p>
        <p>8.4. Le montant que Bolt vous doit pour la Restitution est déterminé dans les CP.</p>
        <h3>9. Facturation et conditions de paiement</h3>
        <p>
          9.1. Nous nous appuyons, conformément à l’article 7.3, sur les relevés mis à notre disposition et sur les profils de consommation
          communiqués par le Gestionnaire de réseau, pour facturer vos prélèvements d’électricité et/ou de gaz naturel. Nous vous envoyons
          des factures d’acompte mensuelles. Nous fixons le montant de ces factures d’acompte sur la base des données que vous nous
          communiquez ou sur la base du décompte périodique, étant entendu que vous pouvez nous demander la révision du montant des factures
          d’acompte. Dans ce cas, nous vous indiquerons dans un délai raisonnable si nous pouvons donner suite à votre demande. Dans la
          mesure où nous avons reçu vos données de mesure du Gestionnaire de réseau, nous vous transmettons chaque année une facture dans
          laquelle nous portons en compte votre consommation effective et tenons compte des acomptes déjà facturés jusqu’au relevé des
          index. Si nous ne recevons pas de relevés du Gestionnaire de réseau, nous pouvons continuer à vous envoyer des factures d’acompte.
          Si nous recevons une consommation estimée du Gestionnaire de réseau, nous vous facturerons cette consommation estimée. Si nous
          constatons que les relevés sont erronés, nous le signalerons au Gestionnaire de réseau et nous continuerons à vous adresser des
          factures d’acompte. Nous procéderons ultérieurement à un décompte de votre consommation effective.
        </p>
        <p>
          9.2. Nos factures peuvent uniquement être payées sur notre compte bancaire, dont le numéro est indiqué sur la facture. Vous devez
          payer nos factures au plus tard dans les 15 jours calendrier à compter de leur date de réception (si la facture est envoyée par
          courrier postal, il s’agit du troisième jour après l’envoi). A défaut de paiement dans les délais, nous vous enverrons au moins un
          rappel. Si vous ne payez pas à temps suite à ce rappel, nous vous enverrons une mise en demeure.
        </p>
        <p>Si nous vous devons un montant, nous vous le rembourserons dans le délai de paiement susmentionné, sauf si :</p>
        <ol type="a">
          <li>
            nous ne connaissons pas votre numéro de compte (auquel cas nous procéderons au paiement/remboursement dans les 15 jours
            calendrier suivant la communication de votre numéro de compte) ; ou
          </li>
          <li>
            vous avez encore des factures impayées, ce qui nous donne le droit de récupérer les montants impayés conformément à la
            réglementation existante.
          </li>
        </ol>
        <p>
          Aucun coût supplémentaire n’est porté en compte au client qui refuse une domiciliation. Vous avez la possibilité d’exclure vos
          factures de décompte et de clôture de votre domiciliation. L’exécution du mandat de domiciliation relative à la facture de clôture
          se fera au plus tôt 15 jours calendrier après la date de réception de la facture de clôture (la date de réception étant le 3e jour
          après l’envoi de la facture si elle a été envoyée par courrier postal et le jour même si elle a été envoyée par e-mail).
        </p>
        <p>
          9.3. L’éventuel redevance que Bolt vous doit pour l’électricité que vous avez injectée sera déduite dans nos factures d’acompte et
          de clôture que vous devez à Bolt pour la fourniture de l’électricité que vous avez consommée. Vous payez le solde à Bolt ou Bolt
          vous paye le solde, selon le cas.
        </p>
        <p>
          9.4. Si vous ou nous pensons que notre facture comporte des données erronées (autres que les relevés), l’autre partie doit être
          contactée par écrit dans les 12 mois de la réception de la facture, sauf si un délai plus long est prévu par la réglementation en
          vigueur. Si la contestation d’une facture impayée est justifiée ou que celle-ci doit faire l’objet d’un examen plus approfondi,
          vous pouvez suspendre le paiement de la partie contestée de la facture jusqu’au moment où le traitement de la plainte est
          finalisé. Nous vous répondrons le plus rapidement possible après réception de la plainte (ou dès que possible après réception par
          un tiers des informations dont nous avons besoin pour répondre à la plainte).
        </p>
        <p>
          9.5. Le retard de paiement d’une facture a pour effet que toute autre facture, même si nous avons accepté un plan de paiement pour
          celle-ci, devient immédiatement exigible, sans mise en demeure.
        </p>
        <p>
          9.6. Dans la mesure autorisée et conformément à la législation en vigueur, nous pouvons imputer des frais administratifs pour
          l’envoi de factures supplémentaires, de duplicata, d’un plan de remboursement, de lettres suite à votre retard de paiement ou si
          la présentation d’une domiciliation est refusée par la banque et/ou la poste. Le coût s’élève à 8 EUR pour une lettre de rappel et
          à 20 EUR pour une mise en demeure, sauf si la réglementation en vigueur prévoit d’autres montants.
        </p>
        <p>
          9.7. En cas de retard de paiement de la totalité ou d’une partie de la facture, ou si la présentation d'une domiciliation est
          refusée par l’institution financière, vous êtes tenu, de plein droit et sans mise en demeure ou rappel, au paiement d’intérêts de
          retard. Les intérêts de retard sont calculés au taux d’intérêt légal si vous êtes un Consommateur et au taux d'intérêt tel que
          prévu dans la loi concernant la lutte contre le retard de paiement dans les transactions commerciales d'août 2002 si vous êtes un
          Petit consommateur professionnel. Les intérêts de retard sont imputés à compter de l'échéance, sur tout montant impayé, jusqu'à la
          date du paiement intégral. En outre, en l’absence de paiement intégral après transmission de votre(vos) facture(s) impayée(s) à un
          tiers (p.ex. huissier de justice, avocat ou agence de recouvrement), vous êtes tenu de plein droit et sans autre mise en demeure
          au paiement d’un dédommagement forfaitaire égal à 10 % de toute facture impayée, avec un minimum de 55 EUR, en compensation des
          frais de recouvrement extrajudiciaires, conformément à la réglementation en vigueur, sans préjudice de notre droit de prouver
          plusieurs dommages, notamment par l’imputation de frais de procédure.
        </p>
        <p>
          9.8. Sauf si la réglementation régionale prévoit un autre dédommagement, vous avez droit à des intérêts de retard au taux
          d’intérêt légal sur tout montant impayé en cas d’erreur de facturation ou de retard de paiement/remboursement dans notre chef. Ces
          intérêts commencent à courir le lendemain du jour où nous aurions dû procéder au paiement conformément à l’article 9.2, ou, en cas
          d’erreur de facturation dans notre chef, à partir de la date de protestation de votre part, jusqu'à la date de paiement complet de
          notre part. Les coûts de vos mises en demeure et de vos rappels seront également à notre charge. En outre, vous avez droit à un
          dédommagement forfaitaire égal à 10 % du montant impayé pour autant que vous deviez faire appel à un tiers (p.ex. huissier de
          justice, avocat ou agence de recouvrement) pour en obtenir le paiement, avec un minimum de 55 EUR, et ce, en compensation des
          frais de recouvrement extrajudiciaires, conformément à la réglementation en vigueur, sans préjudice de votre droit de prouver
          plusieurs dommages, notamment par l’imputation de frais de procédure.
        </p>
        <p>9.9. Si le Contrat de fourniture est résilié, pour quelque raison que ce soit, nous vous transmettons un décompte final.</p>
        <p>
          9.10. Si vous estimez avoir droit au statut de client protégé ou au tarif social, et que cela ne se fait pas automatiquement, vous
          devez nous transmettre le plus vite possible les attestations et pièces justificatives nécessaires.
        </p>
        <h3>10. Responsabilité</h3>
        <p>
          10.1. Sans préjudice des autres dispositions en matière de responsabilité dans le présent Contrat de fourniture et/ou de
          restitution ou dans d’autres dispositions légales, vous et nous ne sommes responsables l’un envers l’autre qu’en cas : (a)
          d’inexécution des principaux engagements du Contrat de fourniture, et/ou de restitution sauf en cas de force majeure ; (b) de
          fraude, faute grave ou intentionnelle ; (c) de décès ou blessure corporelle vous concernant par un acte ou une négligence de la
          part de Bolt.
        </p>
        <p>
          10.2. En cas de responsabilité, seuls les dommages matériels directs seront indemnisés. Toute indemnisation de dommages
          immatériels, tels que les dommages d’exploitation, la perte de bénéfices, de production, de données ou de revenus, est
          expressément exclue. La réparation de tout dommage matériel ne pourra en outre pas excéder 12 fois votre consommation mensuelle
          moyenne des six derniers mois, ou de la durée du Contrat de fourniture et/ou de restitution si celle-ci est plus courte. Cette
          limitation n'est pas d'application en cas de décès ou de blessure corporelle vous concernant causé par un acte ou une négligence
          de la part de Bolt.
        </p>
        <p>
          10.3. Toute demande de dommages et intérêts doit être notifiée à l’autre partie, par écrit, dans les 30 jours calendrier à compter
          de la date de la survenance du dommage ou de la date où le dommage aurait raisonnablement pu être constaté. Les déclarations
          tardives de dommages ne sont pas indemnisées.
        </p>
        <p>
          10.4. Nous ne sommes pas responsables des dommages causés par le mauvais fonctionnement du réseau, des installations au Point de
          fourniture, de l’équipement de mesure, des relevés erronés, des variations de tension et de fréquence, des manquements dans le
          chef du Gestionnaire de réseau, ni des conséquences du non-respect des accords entre vous-même et le Gestionnaire de réseau. Nous
          ne sommes pas non plus responsables de la qualité des données échangées (comme, par exemple, les consommations annuelles standard,
          les profils synthétiques de charge). Tout cela relève de la responsabilité du Gestionnaire de réseau et est indépendant du Contrat
          de fourniture et/ou de restitution.
        </p>
        <p>10.5. Vous nous garantirez contre les actions éventuelles de tiers, notamment vos relations commerciales.</p>
        <h3>
          11. Suspension de la Fourniture et/ou de Restitution et résiliation immédiate du Contrat de fourniture et/ou du Contrat de
          restitution
        </h3>
        <p>
          11.1. En cas de manquement grave de notre part, vous pouvez résilier le Contrat de fourniture et/ou de restitution avant son terme
          par lettre recommandée, avec effet immédiat et sans intervention judiciaire.
        </p>
        <p>
          11.2. Nous pouvons suspendre la Fourniture et/ou la Restitutoin ou résilier le Contrat de fourniture et/ou de restitution avant
          son terme, par lettre recommandée, avec effet immédiat, sans intervention judiciaire ni indemnité, moyennant le respect de la
          réglementation en vigueur, si :
        </p>
        <ol type="a">
          <li>vous ne respectez pas vos obligations de paiement ou d’autres obligations après mise en demeure ;</li>
          <li>
            nous vous demandons de constituer une garantie conformément à l’article 4.3 et vous ne constituez pas cette garantie (dans les
            temps) ;
          </li>
          <li>
            une interruption ou un arrêt de la Fourniture et/ou la Restitution est imposé par le Gestionnaire de réseau ou par une autorité
            compétente ;
          </li>
          <li>vous fraudez ou livrez à des tiers de l’électricité et/ou du gaz naturel que nous avons livré(e) ;</li>
          <li>
            vous vous abstenez de nous informer immédiatement de tout élément dont vous avez connaissance et qui serait susceptible de gêner
            ou d’entraver l’exécution du Contrat de fourniture et/ou de restitution.
          </li>
        </ol>
        <p>
          La résiliation s’opère sans préjudice de notre droit à des dommages et intérêts. En cas de résiliation conformément à l’article
          11.2 (d), ce dédommagement sera au moins égal à la valeur estimée de trois mois de consommation. Si notre dommage est plus élevé,
          nous pourrons aussi le répercuter. Sans préjudice des dispositions des articles 9.5 et 9.6, vous ne serez toutefois pas redevable
          d'une quelconque indemnité si nous résilions le Contrat de fourniture sur la base de l’article 11.2 (a), (b) ou (c). (a), (b) ou
          (c).
        </p>
        <p>
          11.3. En cas de résiliation du Contrat de fourniture avant son terme par vous ou par nous, le Contrat de fourniture est toujours
          résilié dans son intégralité, autrement dit, aussi bien pour l'électricité que pour le gaz naturel. Le cas échéant, un nouveau
          Contrat de fourniture d'électricité ou de gaz naturel pourra être conclu ultérieurement.
        </p>
        <p>
          11.4. Quand le Contrat de restitution est résilié, prématurément ou non, par vous ou par nous, cela n’a aucune incidence sur le
          Contrat de fourniture, sauf indication contraire de votre part ou de la nôtre. Quand le Contrat de restitution est résilié, que ce
          soit prématurément ou non, par vous ou par nous, le Contrat de fourniture est également résilié.
        </p>
        <p>
          11.5. Le Contrat de fourniture est dans les tous cas maintenu tant que Bolt est mentionné dans le registre d’accès en tant que
          responsable de l'approvisionnement de votre Point de fourniture.
        </p>
        <p>12. Déménagement / cession</p>
        <p>
          12.1. En cas de déménagement, le Contrat de fourniture reste entièrement d’application à votre nouvelle adresse. Vous devez nous
          informer de vos projets de déménagement de préférence 30 jours calendrier au préalable (au plus tard 30 jours calendrier après le
          déménagement pour les Consommateurs et 10 jours calendrier après le déménagement pour les Petits consommateurs professionnels) et
          nous communiquer les informations suivantes :
        </p>
        <ol type="a">
          <li>votre future adresse ;</li>
          <li>le(s) code(s) EAN et le numéro de compteur à cette adresse ;</li>
          <li>
            la date à partir de laquelle il convient de fournir au nouveau Point de fourniture et d’arrêter la Fourniture au Point de
            fourniture actuel ; et tous les relevés de compteur de votre ancienne et de votre nouvelle adresse au moment du déménagement.
          </li>
        </ol>
        <p>
          Vous pouvez à cet effet utiliser les canaux de communication que nous mettons à disposition en vue du déménagement, notamment
          notre document de reprise des énergies.
        </p>
        <p>
          Si vous avez conclu un Contrat de restitution avec nous, il restera en vigueur à votre nouvelle adresse, sauf si vous nous
          informez que vous n’injecterez plus d’électricité à votre nouvelle adresse. Dans ce dernier cas, le Contrat de restitution sera
          résilié à la date du déménagement.
        </p>
        <p>
          12.2. Si nous ne sommes pas informés de votre déménagement dans le délai prévu à l'article 12.1, le Contrat de fourniture reste en
          vigueur pour votre ancienne adresse. Cela signifie que vous êtes tenu de payer l'électricité et/ou le gaz naturel prélevé(e) - par
          qui que ce soit - au Point de fourniture que vous quittez, sauf si la réglementation en vigueur prévoit un cadre contraire
          contraignant. Si nous ne sommes pas informés de votre déménagement dans le délai prévu à l'article 12.1, le Contrat de restitution
          prend fin au moment de votre déménagement. L’électricité qui est injectée - par quiconque - au Point de fourniture que vous
          quittez ne sera pas remboursée par Bolt, sauf disposition contraire dans la réglementation applicable.
        </p>
        <p>
          12.3. Nous vous envoyons une facture avec le décompte final pour le Point de fourniture que vous quittez. Si vous ne nous
          communiquez pas le relevé du Point de fourniture que vous quittez dans le délai prévu à l'article 12.1, nous avons dès lors le
          droit de faire relever le compteur par le Gestionnaire de réseau, à vos frais.
        </p>
        <p>
          12.4. Moyennant la production d’une attestation, le Contrat de fourniture peut être résilié, par vous ou par nous, à compter de la
          date de déménagement effective si vous déménagez à l’étranger ou vers une autre région, vers une habitation dans laquelle il n’y a
          pas de compteur séparé pour la consommation d'électricité et/ou de gaz naturel, si vous cohabitez avec un autre utilisateur qui a
          déjà un Contrat de fourniture et/ou de restitution (avec nous ou avec un autre fournisseur), ou encore si vous déménagez vers un
          territoire où nous ne sommes pas (plus) en mesure, pour des raisons objectives, de poursuivre le Contrat de fourniture et/ou de
          restitution.
        </p>
        <p>
          12.5. Nous fournirons l’énergie à votre nouveau Point de fourniture à partir de la date que vous nous aurez communiquée. Les CP du
          Contrat de fourniture et/ou de restitution peuvent être adaptées, ainsi qu’il est prévu à l’article 13 et/ou en fonction de votre
          nouveau Gestionnaire de réseau.
        </p>
        <p>
          12.6. Si vous ne respectez pas les obligations ci-dessus liées à votre déménagement, vous nous autorisez à demander, au
          gestionnaire de réseau, la fermeture du compteur du Point de fourniture que vous quittez. Dans ce cas, tous les frais de fermeture
          seront à votre charge. Nous ne sommes pas responsables des dommages causés dans ce cas.
        </p>
        <h3>13. Modifications du Contrat de fourniture et/ou du Contrat de restitution</h3>
        <p>
          13.1. Pour autant que ces modifications ne soient pas à votre désavantage, nous pouvons apporter des modifications au Contrat de
          fourniture et/ou de restitution à tout moment. Le cas échéant, nous vous communiquerons ces modifications de façon individualisée
          au moins deux mois avant leur entrée en vigueur. La notification par lettre, sur la facture, par e-mail ou sur tout autre support
          durable vaut communication.
        </p>
        <p>
          13.2. En outre, si votre Contrat de fourniture et/ou votre Contrat de restitution est à durée indéterminée, nous pouvons à tout
          moment :
        </p>
        <ul>
          <li>appliquer des augmentations de prix dans le cas d’un Contrat de fourniture ;</li>
          <li>réduire les frais de restitution dans le cas d’un Contrat de restitution ; ou</li>
          <li>apporter des changements à votre détriment.</li>
        </ul>
        <p>
          à condition que nous vous informions de ces changements au moins deux mois avant leur entrée en vigueur, de la même manière que
          celle prévue à l’article 13.1.
        </p>
        <p>
          Vous serez considéré comme ayant accepté ces modifications à moins que, dans le mois suivant la réception de la notification, vous
          ne résiliiez le Contrat de fourniture (dans le cas de modifications du contrat de fourniture) et/ou le Contrat de restitution
          (dans le cas de modifications du Contrat de restitution) conformément à l’article 6.3. En cas de communication par e-mail, le jour
          de réception est le jour de l’envoi de l’e-mail ; si la notification est envoyée par courrier postal, celui-ci sera réputé reçu le
          troisième jour après l'envoi.
        </p>
        <p>
          13.3. Si votre Contrat de fourniture est prolongé conformément à l’article 6.2, nous pouvons néanmoins vous proposer, deux mois
          avant la prolongation, de modifier les prix et/ou les conditions du Contrat de fourniture pour la période suivante. Si vous
          marquez par écrit votre accord sur les modifications, le Contrat de fourniture se poursuivra à ces conditions pour la période
          suivante. Si vous n’acceptez pas ces modifications et si vous n’avez pas changé de fournisseur à l'expiration de la période en
          cours, nous poursuivrons la fourniture aux prix et conditions de notre produit à durée déterminée équivalent le moins cher.
        </p>
        <p>
          13.4. Si votre Contrat de restitution est prolongé conformément à l’article 6.2, nous pouvons néanmoins vous proposer, deux mois
          avant la prolongation, de modifier les prix et/ou les conditions du Contrat de restitution pour la période suivante. Si vous
          marquez par écrit votre accord sur les modifications, le Contrat de fourniture se poursuivra à ces conditions pour la période
          suivante. Si vous ne le faites pas et que vous n’avez pas indiqué un autre fournisseur ou un tiers comme acheteur de l’électricité
          que vous avez injectée, Bolt a le choix de prolonger le Contrat de fourniture aux anciens prix et conditions, ou de ne pas le
          prolonger.
        </p>
        <p>
          13.5. Si, contrairement à ce qui est stipulé aux articles 13.1 et 13.2, les Conditions particulières sont modifiées en
          concertation avec nous, un nouveau Contrat de fourniture et/ou de restitution sera conclu dès que nous aurons intégré cette
          modification dans nos systèmes. Nous vous informerons de cette date.
        </p>
        <p>
          13.6. Nous pouvons céder le Contrat de fourniture et/ou de restitution à un tiers et nous vous en informerons dans ce cas. Ce
          tiers poursuivra la mise en œuvre du Contrat de fourniture et/ou de restitution aux mêmes conditions. Vous ne pouvez pas céder le
          Contrat de fourniture et/ou de restitution à un tiers, ni à un cohabitant, ni à un nouveau résident.
        </p>
        <h3>14. Modification du Producteur d'électricité</h3>
        <p>
          14.1. Le lien entre vous et le Producteur d'électricité est basé sur votre consommation moyenne et la production du Producteur
          d'électricité. Les fluctuations limitées dans votre consommation et la production du Producteur d'électricité seront absorbées par
          de l'électricité issue d'autres producteurs reliés à notre plateforme et produisant également de l'électricité locale et verte.
        </p>
        <p>
          14.2. Si le Producteur d'électricité n'est plus disponible sur notre plateforme ou s'il ne produit plus structurellement une
          quantité d'électricité suffisante pour satisfaire votre consommation d'électricité (en plus de celle des autres clients qui ont
          choisi ce Producteur d'électricité), Bolt vous en informera par écrit, soit par courrier, soit par e-mail. Nous vous proposerons
          un nouveau producteur pour remplacer votre Producteur d'électricité. Dès cette notification, vous disposez d'un mois pour nous
          proposer, par courrier ou par e-mail, un autre nouveau producteur. Ce délai d'un mois entre en vigueur à la date d'envoi de notre
          e-mail ou à partir du troisième jour après l'envoi de notre courrier. Si vous ne nous communiquez pas votre choix d'un autre
          nouveau producteur et que vous ne changez également pas de fournisseur dans ce délai, nous vous associerons au producteur que nous
          avons proposé.
        </p>
        <p>
          14.3. La modification du Producteur d'électricité conformément à l'article 14.2 ne sera pas considérée comme modification du
          Contrat de fourniture.
        </p>
        <h3>15. Responsabilité d’équilibre</h3>
        <p>Pour la responsabilité d’équilibre, tant pour la Fourniture que pour la Restitution, Bolt fait appel à [Luminus].</p>
        <h3>16. Force majeure</h3>
        <p>
          16.1. En cas de force majeure, les obligations découlant du présent Contrat de fourniture et/ou de restitution, à l’exception de
          l’obligation de paiement d’une somme d’argent, sont suspendues ou limitées pendant la période de force majeure. Par ‘force
          majeure’ il y a lieu d’entendre : tout événement imprévisible et inévitable indépendant de la volonté d'une partie qui constitue
          un obstacle insurmontable pour le respect de l'engagement de cette partie, comme, mais sans s’y limiter, une panne du réseau, des
          problèmes au niveau du transport ou de la distribution, l’impossibilité d’obtenir de l’électricité ou du gaz naturel (en quantité
          suffisante), catastrophes naturelles, grèves.
        </p>
        <p>
          16.2. Si le Contrat de fourniture ne peut pas être exécuté pendant plus de trois mois en raison d’un cas de force majeure, aussi
          bien vous que nous avons le droit de résilier le Contrat de fourniture et/ou de restitution par écrit, sans qu’une indemnité ne
          soit due à l’autre partie.
        </p>
        <h3>17. Protection de la vie privée</h3>
        <p>
          En tant que responsable du traitement de vos données à caractère personnel, nous traitons toujours vos données à caractère
          personnel en conformité avec la réglementation applicable en matière de protection de la vie privée. Nous traitons vos données à
          caractère personnel aux fins et motifs décrits dans notre politique de confidentialité telle qu’elle figure sur notre site
          internet www.boltenergie.be à la rubrique « Mentions légales et Politique de confidentialité » (ci-après 'la Politique de
          confidentialité'). En approuvant et acceptant expressément le Contrat de fourniture et/ou de restitution, vous confirmez avoir
          pris connaissance de la Politique de confidentialité et accepter le traitement de vos données à caractère personnel conformément à
          la Politique de confidentialité.
        </p>
        <h3>18. Absence d'abandon de droit</h3>
        <p>
          Le fait de ne pas poursuivre l’exécution d’une disposition quelconque du Contrat de fourniture et/ou de restitution ne peut être
          considéré comme un abandon ou une limitation de ce droit.
        </p>
        <h3>19. Dispositions nulles</h3>
        <p>
          La nullité ou l’invalidité d’une des dispositions du Contrat de fourniture et/ou de restitution n’aura pas d’incidence sur la
          validité des autres dispositions du Contrat de fourniture et/ou de restitution. Si une des dispositions est nulle ou non valable,
          cette disposition nulle ou non valable sera remplacée, autant que possible, par une disposition valable qui se rapprochera le plus
          possible de l’objectif initial des parties.
        </p>
        <h3>20. Droit applicable et litiges - plaintes</h3>
        <p>20.1. Le droit belge s’applique au Contrat de fourniture et/ou de restitution.</p>
        <p>
          20.2. En cas de plaintes, vous pouvez vous adresser à notre service clientèle, dont vous retrouvez les coordonnées sur votre
          facture ou sur notre website. Si votre Contrat de fourniture et/ou de restitution a été conclu en ligne, rendez-vous sur la
          plate-forme ODR pour faire des réclamations en ligne (
          <a href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a>).
        </p>
        <p>
          20.3. Les litiges concernant le Contrat de fourniture et/ou de restitution peuvent être portés, au choix de la partie
          demanderesse, devant le juge du domicile de la partie défenderesse ou devant le juge du lieu où l'engagement auquel le litige se
          rapporte est survenu ou où il doit être exécuté.
        </p>
        <h3>MODÈLE DE FORMULAIRE DE RÉTRACTATION</h3>
        <p>
          Veuillez compléter et renvoyer le présent formulaire à Bolt uniquement si vous souhaitez vous rétracter du Contrat de fourniture
          et/ou de restitution.
        </p>
        <p>Veuillez renvoyer ce document à Bolt :</p>
        <p>Par courrier postal : (remplir l'adresse)</p>
        <p>Par e-mail : (remplir l'adresse mail)</p>
        <p>
          Je vous notifie par la présente ma rétractation du Contrat de fourniture portant sur la fourniture et/ou de restitution
          d'électricité / gaz*. (Biffer la mention inutile).
        </p>
        <p>Nom de produit :</p>
        <p>Date de confirmation du Contrat de fourniture et/ou de restitution :</p>
        <p>
          <i>
            Si le Contrat de fourniture et/ou de restitution a été conclu par téléphone : la date à laquelle vous avez confirmé la Contrat
            de fourniture et/ou de restitution.
          </i>
        </p>
        <p>
          <i>Dans tous les autres cas : la date à laquelle Bolt a confirmé le Contrat de fourniture et/ou de restitution.</i>
        </p>
        <p>Nom Consommateur :</p>
        <p>Adresse Consommateur :</p>
        <p>Date :</p>
        <p>Signature :</p>
      </div>
    )
  }

  return (
    <>
      {language === Language.DUTCH && renderDutch()}
      {language === Language.FRENCH && renderFrench()}
    </>
  )
}

export default Terms
